module.exports = __webpack_public_path__ + "assets/img/tgsm1.c68aba3a.png";